/* Liviza header: hover-dropdowns, sticky reveal, drawer en live zoeken (Shopify Predictive Search). */
(function () {
  if (customElements.get('lv-header')) return;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var norm = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  var ICON_ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"></path><path d="m13 6 6 6-6 6"></path></svg>';

  class LvHeader extends HTMLElement {
    connectedCallback() {
      this.group = this.closest('#header-group') || this.parentElement;
      this.desktop = window.matchMedia('(min-width: 1180px)');
      this.openId = null; this.tOpen = null; this.tClose = null;
      this.lastY = window.scrollY; this.ticking = false;
      this.q = ''; this.active = -1; this.flat = []; this.ctrl = null; this.tSearch = null;
      this.lastFocus = null;
      this.bind();
      this.measure();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('keydown', this._onKey);
      document.documentElement.classList.remove('lvh-lock');
    }

    /* ---------- Opbouw ---------- */
    bind() {
      var self = this;
      this._onScroll = function () { if (!self.ticking) { self.ticking = true; requestAnimationFrame(function () { self.onScroll(); self.ticking = false; }); } };
      this._onResize = function () { self.measure(); if (!self.desktop.matches) self.closeMenu(true); };
      this._onKey = function (e) { self.onKey(e); };
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize);
      document.addEventListener('keydown', this._onKey);

      this.querySelectorAll('[data-dd]').forEach(function (btn) {
        var id = btn.getAttribute('data-dd');
        btn.addEventListener('mouseenter', function () { if (self.desktop.matches) self.hoverOpen(id); });
        if (btn.hasAttribute('data-dd-link')) {
          /* Link met menu: hover opent, klik gaat naar de pagina. Op touch opent de eerste tik het menu. */
          var noHover = window.matchMedia('(hover: none)');
          btn.addEventListener('click', function (e) { if (noHover.matches && self.openId !== id) { e.preventDefault(); self.openMenu(id); } });
          btn.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown') { e.preventDefault(); self.openMenu(id); var f = self.querySelector('[data-panel="' + id + '"] a'); if (f) f.focus(); }
          });
          return;
        }
        btn.addEventListener('click', function () { self.openId === id ? self.closeMenu(true) : self.openMenu(id); });
      });
      this.querySelectorAll('.lvh-nav__link:not([data-dd]), .lvh-logo, .lvh-actions').forEach(function (el) {
        el.addEventListener('mouseenter', function () { if (self.desktop.matches && self.openId) self.closeMenu(); });
      });
      this.querySelectorAll('[data-panel]').forEach(function (p) {
        p.addEventListener('mouseenter', function () { clearTimeout(self.tClose); });
        p.addEventListener('mouseleave', function () { if (self.desktop.matches) self.closeSoon(); });
      });
      var bar = this.querySelector('.lvh-bar');
      if (bar) bar.addEventListener('mouseleave', function (e) {
        if (!self.desktop.matches) return;
        if (e.relatedTarget && e.relatedTarget.closest && e.relatedTarget.closest('[data-panel]')) return;
        self.closeSoon();
      });
      var bd = this.querySelector('[data-backdrop]');
      if (bd) bd.addEventListener('click', function () { self.closeMenu(true); });

      this.drawer = this.querySelector('[data-drawer]');
      this.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { self.openDrawer(b); }); });
      this.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeDrawer(); }); });
      this.querySelectorAll('[data-acc]').forEach(function (b) {
        b.addEventListener('click', function () {
          var sub = document.getElementById(b.getAttribute('aria-controls'));
          var open = b.getAttribute('aria-expanded') === 'true';
          self.querySelectorAll('[data-acc][aria-expanded="true"]').forEach(function (o) {
            o.setAttribute('aria-expanded', 'false'); var s = document.getElementById(o.getAttribute('aria-controls')); if (s) s.hidden = true;
          });
          if (!open) { b.setAttribute('aria-expanded', 'true'); if (sub) sub.hidden = false; }
        });
      });
      if (this.drawer) this.drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { self.closeDrawer(); }); });

      this.search = this.querySelector('[data-search]');
      this.input = this.querySelector('[data-search-input]');
      this.emptyEl = this.querySelector('[data-search-empty]');
      this.resEl = this.querySelector('[data-search-results]');
      this.querySelectorAll('[data-search-open]').forEach(function (b) { b.addEventListener('click', function () { self.openSearch(b); }); });
      this.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { self.closeSearch(); }); });
      this.querySelectorAll('[data-chip]').forEach(function (c) {
        c.addEventListener('click', function () { self.input.value = c.getAttribute('data-chip'); self.onInput(); self.input.focus(); });
      });
      if (this.input) {
        this.input.addEventListener('input', function () { self.onInput(); });
        this.input.addEventListener('keydown', function (e) { self.onSearchKey(e); });
      }
    }

    measure() {
      var top = this.querySelector('.lvh-top');
      var h = top ? top.offsetHeight : 0;
      if (this.group) this.group.style.setProperty('--lvh-top-h', h + 'px');
    }

    /* ---------- Sticky: verbergen bij omlaag, tonen bij omhoog ---------- */
    onScroll() {
      var y = window.scrollY, down = y > this.lastY + 2, up = y < this.lastY - 2;
      var limit = (this.offsetHeight || 120) + 80;
      if (this.group && !this.openId && !this.isLocked()) {
        if (down && y > limit) this.group.classList.add('lvh-is-hidden');
        else if (up || y <= limit) this.group.classList.remove('lvh-is-hidden');
      }
      if (down && this.openId && this.desktop.matches && y > limit) this.closeMenu(true);
      this.lastY = y;
    }
    isLocked() { return document.documentElement.classList.contains('lvh-lock'); }

    /* ---------- Dropdowns ---------- */
    hoverOpen(id) {
      var self = this; clearTimeout(this.tClose); clearTimeout(this.tOpen);
      if (this.openId) { this.openMenu(id); return; }
      this.tOpen = setTimeout(function () { self.openMenu(id); }, 90);
    }
    openMenu(id) {
      clearTimeout(this.tClose); clearTimeout(this.tOpen);
      var self = this;
      this.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== id; });
      this.querySelectorAll('[data-dd]').forEach(function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-dd') === id ? 'true' : 'false'); });
      this.openId = id; this.classList.add('is-open');
      if (this.group) this.group.classList.remove('lvh-is-hidden');
    }
    closeSoon() { var self = this; clearTimeout(this.tOpen); clearTimeout(this.tClose); this.tClose = setTimeout(function () { self.closeMenu(); }, 180); }
    closeMenu(now) {
      clearTimeout(this.tOpen); clearTimeout(this.tClose);
      this.querySelectorAll('[data-panel]').forEach(function (p) { p.hidden = true; });
      this.querySelectorAll('[data-dd]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      this.openId = null; this.classList.remove('is-open');
    }

    /* ---------- Drawer ---------- */
    openDrawer(trigger) {
      this.lastFocus = trigger || document.activeElement;
      if (this.group) this.group.classList.remove('lvh-is-hidden');
      this.drawer.classList.add('is-open');
      document.documentElement.classList.add('lvh-lock');
      this.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var c = this.drawer.querySelector('[data-drawer-close]'); if (c) setTimeout(function () { c.focus(); }, 50);
    }
    closeDrawer(keepLock) {
      if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
      this.drawer.classList.remove('is-open');
      if (!keepLock) document.documentElement.classList.remove('lvh-lock');
      this.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (this.lastFocus && !keepLock) this.lastFocus.focus();
    }

    /* ---------- Toetsenbord ---------- */
    onKey(e) {
      if (e.key !== 'Escape') return;
      if (this.search && this.search.classList.contains('is-open')) { this.closeSearch(); return; }
      if (this.drawer && this.drawer.classList.contains('is-open')) { this.closeDrawer(); return; }
      if (this.openId) { var b = this.querySelector('[data-dd="' + this.openId + '"]'); this.closeMenu(true); if (b) b.focus(); }
    }

    /* ---------- Zoeken ---------- */
    openSearch(trigger) {
      this.closeMenu(true);
      var fromDrawer = this.drawer && this.drawer.classList.contains('is-open');
      if (fromDrawer) this.closeDrawer(true);
      this.lastFocus = fromDrawer ? this.querySelector('[data-drawer-open]') : (trigger || document.activeElement);
      if (this.group) this.group.classList.remove('lvh-is-hidden');
      this.search.classList.add('is-open');
      document.documentElement.classList.add('lvh-lock');
      var i = this.input; setTimeout(function () { i.focus(); }, 30);
    }
    closeSearch() {
      this.search.classList.remove('is-open');
      document.documentElement.classList.remove('lvh-lock');
      this.input.value = ''; this.onInput();
      if (this.lastFocus) this.lastFocus.focus();
    }
    onInput() {
      var self = this, q = this.input.value.trim();
      this.q = q; this.active = -1;
      clearTimeout(this.tSearch);
      if (!q) { this.emptyEl.hidden = false; this.resEl.hidden = true; this.resEl.innerHTML = ''; this.flat = []; return; }
      this.tSearch = setTimeout(function () { self.fetchResults(q); }, 180);
    }
    fetchResults(q) {
      var self = this;
      if (this.ctrl) this.ctrl.abort();
      this.ctrl = window.AbortController ? new AbortController() : null;
      var base = this.dataset.suggestUrl || '/search/suggest';
      var url = base + '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article&resources[limit]=4' +
        '&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag';
      if (!this.resEl.innerHTML) { this.emptyEl.hidden = true; this.resEl.hidden = false; this.resEl.innerHTML = '<div class="lvh-loading">Zoeken…</div>'; }
      fetch(url, this.ctrl ? { signal: this.ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (data) { if (q === self.q) self.renderResults(q, (data.resources && data.resources.results) || {}); })
        .catch(function (err) { if (err && err.name === 'AbortError') return; if (q === self.q) self.renderResults(q, {}); });
    }
    hl(title, q) {
      var t = String(title || ''), first = norm(q).split(/\s+/)[0] || '';
      var i = first ? norm(t).indexOf(first) : -1;
      if (i < 0) return esc(t);
      return esc(t.slice(0, i)) + '<mark>' + esc(t.slice(i, i + first.length)) + '</mark>' + esc(t.slice(i + first.length));
    }
    price(p) {
      if (p == null || p === '') return '';
      var n = parseFloat(p); if (isNaN(n)) return '';
      return '€ ' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    renderResults(q, r) {
      var self = this, html = '';
      var groups = [
        { key: 'products', label: 'Producten' },
        { key: 'collections', label: 'Collecties' },
        { key: 'pages', label: "Pagina's" },
        { key: 'articles', label: 'Projecten & artikelen' }
      ];
      this.flat = [];
      groups.forEach(function (g) {
        var items = r[g.key] || [];
        if (!items.length) return;
        html += '<div class="lvh-res__group"><span class="lvh-eyebrow">' + g.label + '</span>';
        items.forEach(function (it) {
          var img = it.featured_image && it.featured_image.url ? it.featured_image.url : (it.image || '');
          if (img && typeof img === 'object') img = img.url || '';
          var sub = '';
          if (g.key === 'products') sub = it.product_type || '';
          else if (g.key === 'collections') sub = 'Collectie';
          else if (g.key === 'pages') sub = 'Pagina';
          else sub = 'Project';
          var ini = esc(String(it.title || '').slice(0, 2).toUpperCase());
          var thumb = img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" loading="lazy">' : ini;
          html += '<a class="lvh-res" href="' + esc(it.url) + '" data-idx="' + self.flat.length + '"><span class="lvh-res__img">' + thumb + '</span><span class="lvh-res__t"><b>' + self.hl(it.title, q) + '</b>' + (sub ? '<small>' + esc(sub) + '</small>' : '') + '</span></a>';
          self.flat.push(it.url);
        });
        html += '</div>';
      });
      var searchUrl = (this.dataset.searchUrl || '/search') + '?q=' + encodeURIComponent(q) + '&options[prefix]=last';
      if (this.flat.length) {
        html += '<a class="lvh-res__all" href="' + esc(searchUrl) + '">Bekijk alle resultaten voor “' + esc(q) + '” ' + ICON_ARROW + '</a>';
      } else {
        html = '<div class="lvh-none"><p>Geen resultaten voor “' + esc(q) + '”.</p><a href="' + esc(this.dataset.ctaUrl || '/pages/contact') + '"><b>' + esc(this.dataset.ctaLabel) + '</b><span>' + esc(this.dataset.ctaText) + '</span></a></div>';
      }
      this.emptyEl.hidden = true; this.resEl.hidden = false; this.resEl.innerHTML = html;
    }
    onSearchKey(e) {
      var items = this.resEl.querySelectorAll('.lvh-res');
      if (!items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.active = e.key === 'ArrowDown' ? (this.active + 1) % items.length : (this.active <= 0 ? items.length - 1 : this.active - 1);
        items.forEach(function (el, i) { el.classList.toggle('is-active', i === this.active); }, this);
        items[this.active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.active > -1) {
        e.preventDefault(); window.location.href = items[this.active].getAttribute('href');
      }
    }
  }
  customElements.define('lv-header', LvHeader);
})();
